import { apiService } from '@/services/APIService';

const PATH = '/own-exchanges';

export default {
  getExchangeOrganizations(id, params) {
    return apiService.get(`/own-exchanges/${id}/organizers`, params);
  },

  getEventExchangeOrganizations(params) {
    return apiService.get('/own-exchanges/organizers', params);
  },

  createOrganizationExchange(id, params) {
    return apiService.post(`/own-exchanges/${id}`, params);
  },

  confirmOrganization(id, params) {
    return apiService.post(`/own-exchanges/${id}/confirm`, params);
  },

  getEventExchangeOrganizationsForEvent(id, params) {
    return apiService.get(`/own-exchanges/events/${id}/organizers`, params);
  },

  // from CRUD

  getAll(params) {
    return apiService.get(PATH, params);
  },

  get(id, params) {
    return apiService.get(`${PATH}/${id}`, params);
  },

  create(payload) {
    return apiService.post(PATH, payload);
  },

  update(id, payload) {
    return apiService.put(`${PATH}/${id}`, payload);
  },

  delete(id) {
    return apiService.delete(`${PATH}/${id}`);
  },

  deleteAll(payload) {
    return apiService.delete(PATH, payload);
  },
};
